
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import { isNullOrUndefined } from "util";
import axios from "axios";

// export function importCustomer(filePath, originalFileName){
//   return (dispatch, getState) =>{

//       return database.collection("CustomerImport").add({
//           Action:'NEW',
//           ActionOn:firebase.firestore.FieldValue.serverTimestamp(),
//           ActionBy:getState().user.user.Name,
//           ActionByEmailID:getState().user.user.EmailID,
//           ActionByUID:getState().user.user.UID,
//           FilePath:filePath,
//           RegistrationID:getState().user.user.RegistrationID,
//           OriginalFileName:originalFileName
//       })
//       .then(function(docRef) {
//           return docRef.id
//           console.log('customerimport',docRef.id)
//       })
//       .catch(function(error) {
//           console.error("Error adding customer import: ", error);
//       })
//   }
// }


export function getCustomerDetailsByStoreID(storeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/crm/customers/customerdetailsbystoreid/${storeID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return response.data.customer;
      }
      else{
        return {};
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function addCustomer(customer) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/crm/customers`,
        customer,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.newCustomer.key;
      } else {
        alert(response.data.message || "Failed to create customer");
        return null;
      }
    } catch (error) {
      console.error("API Error:", error.response.data || error.message);
      alert(error.response.data.message);
      return null;
    }
  };
}


// export function addCustomer(customer){
//   return (dispatch, getState) => {
//     let newCustomerDoc = database.collection('Customers').doc()
//     customer.ActionOn = firebase.firestore.FieldValue.serverTimestamp()
//     customer.ActionBy = getState().user.user.Name
//     customer.ActionByUID = getState().user.user.UID
//     customer.ActionByEmailID = getState().user.user.EmailID
//     customer.CreatedOn = firebase.firestore.FieldValue.serverTimestamp()
//     customer.Action = constants.AUDIT_TRAIL_NEW

//     newCustomerDoc.set(customer)
//     return newCustomerDoc.id;
//   }
// }


export function getCustomers(
  from = 0,
  size = 100,
  option = "active",
  customerDetails = null,
  phoneNo = null,
  emailID = null,
  city = null,
  state = null,
  postalCode = null,
  country = null,
  membershipName = null,
  customField1 = null,
  isExport = null,
  pitId = null,
  searchAfter = null,
  segment = null,
  wallet = null,
   isGetCustomerSpentAmountAndNoOfVisit=false,
   storeID=""
) {

  return async (dispatch, getState) => {

    try {

      const token = getState().user.uat;

      let apiUrl = "/crm/customers";
      let queryParams = [];

        if(option=="active") {
 queryParams.push(`isDeleted=${false}`);
    }
        if(option=="inActive") {
 queryParams.push(`isDeleted=${true}`);
    }

        if(isGetCustomerSpentAmountAndNoOfVisit) {
 queryParams.push(`isGetCustomerSpentAmountAndNoOfVisit=${isGetCustomerSpentAmountAndNoOfVisit}`);
    }
    
       if (storeID) {
      queryParams.push(`storeID=${(storeID)}`);
    }

      if (from) {
      queryParams.push(`from=${(from)}`);
    }
     if (isExport) {
      queryParams.push(`isExport=${(isExport)}`);
    }
   if (pitId !== undefined && pitId !== null) {
        queryParams.push(`pitId=${encodeURIComponent(pitId)}`);
      }

      if (searchAfter !== undefined && searchAfter !== null) {
        queryParams.push(`searchAfter=${encodeURIComponent(searchAfter)}`);
      }
    
    if (size) {
      queryParams.push(`size=${(size)}`);
    }
    // Add other parameters if they exist
    if (customerDetails) {
      queryParams.push(`customerDetails=${(customerDetails)}`);
    }
      if (segment) {
      queryParams.push(`segment=${(segment)}`);
    }
     if (wallet) {
      queryParams.push(`wallet=${(wallet)}`);
    }
    if (phoneNo) {
      queryParams.push(`phoneNo=${(phoneNo)}`);
    }
    if (emailID) {
      queryParams.push(`emailID=${(emailID)}`);
    }
    if (city) {
      queryParams.push(`city=${(city)}`);
    }
    if (state) {
      queryParams.push(`state=${(state)}`);
    }
    if (postalCode) {
      queryParams.push(`postalCode=${(postalCode)}`);
    }
    if (country) {
      queryParams.push(`country=${(country)}`);
    }
    if (membershipName) {
      queryParams.push(`membershipName=${(membershipName)}`);
    }
    if (customField1) {
      queryParams.push(`customField1=${(customField1)}`);
    }
      apiUrl += queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        constants.API_URL + apiUrl,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );

    return response.data
    } catch (error) {

      console.error("Error fetching customer:", error);

      if (
        error &&
        error.hasOwnProperty("response") &&
        error.response &&
        error.response.hasOwnProperty("data")
      ) {
        throw error.response.data;
      }

      throw error;

    }

  };

};
// export function getCustomersold(
//   RegistrationID,
//   StoreID,
//   from,
//   size,
//   option,
//   searchText,
//   searchCity,
//   searchState,
//   searchPinCode,
//   searchCountry,
//   searchMembership,
//   searchWalletFrom,
//   searchWalletTo,
//   customField1,
//   customField2,
//   customField3,
//   customField4,
//   customField5,
//   customField6
// ) {
//   return (dispatch) => {
//     let searchParameters = {
//       from: from,
//       size: size,
//       track_total_hits: true,
//       query: {
//         bool: {
//           must: [
//             { match: { RegistrationID: RegistrationID } },
//             {
//               match: {
//                 StoreID: StoreID,
//               },
//             },
//           ],
//           must_not: [],
//           should: [],
//           minimum_should_match: 1,
//           filter: {
//             bool: {
//               must: [],
//             },
//           },
//         },
//       },
//       sort: [
//         {
//           ActionOn: {
//             order: "desc",
//           },
//         },
//       ],
//     };
//     if (option === "active") {
//       searchParameters.query.bool.must_not.push({
//         match: { IsDeleted: "true" },
//       });
//     }
//     if (option === "inactive") {
//       searchParameters.query.bool.must_not.push({
//         match: { IsDeleted: "false" },
//       });
//     }
//     searchParameters.query.bool.should.push({
//       regexp: { CustomerDetails: "@" + searchText + ".*" },
//     });
//     searchParameters.query.bool.should.push({
//       match: { CustomerDetails: { query: searchText, operator: "and" } },
//     });
//     searchParameters.query.bool.should.push({
//       regexp: { EmailID: "@" + searchText.trim().toLowerCase() + ".*" },
//     });
//     searchParameters.query.bool.should.push({
//       regexp: { PhoneNo: "@" + searchText.trim().toLowerCase() + ".*" },
//     });
//     if (searchCity.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           "Addresses.City": "@" + searchCity.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (searchState.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           "Addresses.State": "@" + searchState.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (searchPinCode.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           "Addresses.PostalCode":
//             "@" + searchPinCode.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (searchCountry.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           "Addresses.Country": "@" + searchCountry.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (searchMembership.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           "Membership.Name": "@" + searchMembership.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (searchWalletFrom !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         range: { WalletBalance: { gte: searchWalletFrom } },
//       });
//     }
//     if (searchWalletTo !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         range: { WalletBalance: { lte: searchWalletTo } },
//       });
//     }
//     if (customField1.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           CustomField1: "@" + customField1.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (customField2.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           CustomField2: "@" + customField2.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (customField3.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           CustomField3: "@" + customField3.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (customField4.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           CustomField4: "@" + customField4.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (customField5.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           CustomField5: "@" + customField5.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     if (customField6.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({
//         regexp: {
//           CustomField6: "@" + customField6.trim().toLowerCase() + ".*",
//         },
//       });
//     }
//     // console.log('searchParameters',searchParameters)
//     let addMessage = firebase.functions().httpsCallable("getCustomers");
//     return addMessage({ text: searchParameters }).then(function(result) {
//       const customers = [];
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data, index) => {
//         customers.push({ key: data._id, ...data._source });
//       });
//       return {
//         totalItemsCount: sanitizedMessage.hits.total.value,
//         searchResult: customers,
//       };
//     });
//   };
// }

// export function getCustomers(RegistrationID, StoreID, from, size, option, searchText, searchCity,
//   searchState, searchPinCode, searchCountry,
//   customField1, customField2, customField3, customField4, customField5, customField6) {
//   return (dispatch) => {
//     let searchParameters = {
//       "from": from,
//       "size": size,
//       "query": {
//         "bool": {
//           "must": [
//             { "match": { "RegistrationID": RegistrationID } }
//             , {
//               "match": {
//                 "StoreID": StoreID
//               }
//             }
//           ],
//           "must_not": [
//           ],
//           "should": [

//           ],
//           "minimum_should_match": 1,
//           "filter": {
//             "bool": {
//               "must": [

//               ]
//             }
//           }
//         }
//       },
//       "sort": [
//         {
//           "ActionOn": {
//             "order": "desc"
//           }
//         }
//       ]
//     }
//     if (option === "active") {
//       searchParameters.query.bool.must_not.push({ "match": { "IsDeleted": "true" } })
//     }
//     if (option === "inactive") {
//       searchParameters.query.bool.must_not.push({ "match": { "IsDeleted": "false" } })
//     }
//     searchParameters.query.bool.should.push({ "regexp": { "CustomerDetails": "@" + searchText + ".*" } })
//     searchParameters.query.bool.should.push({ "match": { "CustomerDetails": { "query": searchText, "operator": "and" } } })
//     searchParameters.query.bool.should.push({ "regexp": { "EmailID": "@" + searchText.trim().toLowerCase() + ".*" } })
//     searchParameters.query.bool.should.push({ "regexp": { "PhoneNo": "@" + searchText.trim().toLowerCase() + ".*" } })
//     if (searchCity.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "Addresses.City": "@" + searchCity.trim().toLowerCase() + ".*" } })
//     }
//     if (searchState.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "Addresses.State": "@" + searchState.trim().toLowerCase() + ".*" } })
//     }
//     if (searchPinCode.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "Addresses.PostalCode": "@" + searchPinCode.trim().toLowerCase() + ".*" } })
//     }
//     if (searchCountry.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "Addresses.Country": "@" + searchCountry.trim().toLowerCase() + ".*" } })
//     }
//     if (customField1.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "CustomField1": "@" + customField1.trim().toLowerCase() + ".*" } })
//     }
//     if (customField2.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "CustomField2": "@" + customField2.trim().toLowerCase() + ".*" } })
//     }
//     if (customField3.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "CustomField3": "@" + customField3.trim().toLowerCase() + ".*" } })
//     }
//     if (customField4.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "CustomField4": "@" + customField4.trim().toLowerCase() + ".*" } })
//     }
//     if (customField5.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "CustomField5": "@" + customField5.trim().toLowerCase() + ".*" } })
//     }
//     if (customField6.trim() !== "") {
//       searchParameters.query.bool.filter.bool.must.push({ "regexp": { "CustomField6": "@" + customField6.trim().toLowerCase() + ".*" } })
//     }
//     let addMessage = firebase.functions().httpsCallable('getCustomers');
//     return addMessage({ text: searchParameters }).then(function (result) {
//       const customers = []
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data, index) => {
//         customers.push({ key: data._id, ...data._source })
//       })
//       return { totalItemsCount: sanitizedMessage.hits.total.value, searchResult: customers }
//     });
//   }
// }

// export function searchCustomer(RegistrationID, StoreID, searchText) {
//   return (dispatch, getState) => {
//     let searchParameters = {
//       from: 0,
//       size: 50,
//       track_total_hits: true,
//       query: {
//         bool: {
//           must: [
//             { match: { RegistrationID: RegistrationID } },
//             { match: { IsDeleted: "false" } },
//           ],
//           should: [
//             {
//               match: {
//                 CustomerDetails: {
//                   query: searchText.toLowerCase(),
//                   operator: "and",
//                 },
//               },
//             },
//             {
//               regexp: {
//                 CustomerDetails: "@" + searchText.toLowerCase() + ".*",
//               },
//             },
//           ],
//           minimum_should_match: 1,
//         },
//       },
//     };
//     if (getState().registration.registration.hasOwnProperty("GlobalCustomer")) {
//       if (!getState().registration.registration.GlobalCustomer) {
//         searchParameters.query.bool.must.push({ match: { StoreID: StoreID } });
//       }
//     }
//     console.log("Search Customer", JSON.stringify(searchParameters));
//     let addMessage = firebase.functions().httpsCallable("getCustomers");
//     return addMessage({ text: searchParameters }).then(function(result) {
//       const customers = [];
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.hits.hits.map((data, index) => {
//         customers.push({ key: data._id, ...data._source });
//       });
//       console.log("Search Customer", customers);
//       return {
//         totalItemsCount: sanitizedMessage.hits.total.value,
//         searchResult: customers,
//       };
//     });
//   };
// }
export function searchCustomer(RegistrationID, storeID, searchText) {
  return async (dispatch, getState) => {
    try {
      let storeId = null;

      if (
        getState().registration.registration.hasOwnProperty("GlobalCustomer")
      ) {
        if (!getState().registration.registration.GlobalCustomer) {
          storeId = storeID;
        }
      }

      const params = {
        searchText: searchText,
        ...(storeId && { storeId }),
      };

      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/customers/search`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code == "0") {
        return {
          totalItemsCount: response.data.totalCount,
          searchResult: response.data.customers,
        };
      } else {
        return [];
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getCustomerDetails(customerID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/crm/customers/customerdetails/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return response.data.customer;
      }
      else{
        return {};
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}





export function updateCustomer(customer, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

       const response = await axios.put(
        `${constants.API_URL}/crm/customers/${key}`,
        customer,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data;

      if (data.code == "0") {
        return true;
      } else {
      

        return false;
      }
    } catch (error) {
      return false;
    }
  };
}



export function deleteCustomer(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/crm/customers/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data;

      if (data.code == "0") {
        return true;
      } else {
      

        return false;
      }
    } catch (error) {
      return false;
    }
  };
}




export function getCustomerDashboardHeaders(customerID){
  return async (dispatch, getState) => {
    try {
      
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/customers/dashboardhraders/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return {
          totalItemsCount: response.data.totalItemsCount || 0,
          searchResult: response.data.searchResult || [],
        };
      } else {
        alert("Failed to fetch customer dashboard");

        return {
          totalItemsCount: 0,
          searchResult: [],
        };
      }
    } catch (error) {
      console.error("API Error:", error);

      return {
        totalItemsCount: 0,
        searchResult: [],
      };
    }
  };
}


// export function getCustomerDashboardHeaders(customerID) {
//   let searchParameters = {
//     "size": 0,
//     "query": {
//       "bool": {
//         "must": [
//           {
//             "match": {
//               "Customer.key.keyword": customerID
//             }
//           }
//         ],
//         "must_not": [
//           {
//             "exists": {
//               "field": "CancellationReason"
//             }
//           }
//         ]
//       }
//     },
//     "aggs": {
//       "total_spent": {
//         "sum": {
//           "field": "BillAmount"
//         }
//       },
//       "total_qty": {
//         "sum": {
//           "field": "BillQty"
//         }
//       },
//       "total_transactions": {
//         "cardinality": {
//           "field": "_id"
//         }
//       }
//     }
//   };
//   return (dispatch) => {
//     // console.log("Get Customer Dashboard Header - Query", JSON.stringify(searchParameters));
//     let addMessage = firebase.functions().httpsCallable('getSales');
//     return addMessage({ text: searchParameters }).then(function (result) {
//       const header = {};
//       let sanitizedMessage = result.data.text;
//       // console.log("Customer Dashboard Header Data", JSON.stringify(sanitizedMessage));
//       header.total_spent = Number(sanitizedMessage.aggregations.total_spent.value).toFixed(2);
//       header.total_transactions = sanitizedMessage.aggregations.total_transactions.value;
//       header.total_qty = Number(sanitizedMessage.aggregations.total_qty.value).toFixed(2);
//       // console.log("Customer Dashboard Header Data", JSON.stringify(header));
//       return { totalItemsCount: sanitizedMessage.hits.total.value, searchResult: header }
//     });
//   }
// };

export function getWalletLedgersByCustomerID(customerID) {
  return async (dispatch, getState) => {
    try {
      const params = {
        customerID: customerID,
        searchTransactionToDate: "",
        searchTransactionFromDate: "",
        searchTransactionNo: "",
        from: 0,
        size: 100,
      };

      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/customers/walletledges`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return {
          totalItemsCount: response.data.totalItemsCount || 0,
          searchResult: response.data.searchResult || [],
        };
      } else {
        alert("Failed to fetch wallet ledger");

        return {
          totalItemsCount: 0,
          searchResult: [],
        };
      }
    } catch (error) {
      console.error("API Error:", error);

      return {
        totalItemsCount: 0,
        searchResult: [],
      };
    }
  };
}


export function getCustomerTransactions(customerID,from = 0, size = 50) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

       const response = await axios.get(
        `${constants.API_URL}/crm/customers/transaction/${customerID}`,
        {
          params: {
            from: from,
            size: size
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.code === "0") {
        return {
          totalItemsCount: response.data.totalItemsCount || 0,
          searchResult: response.data.searchResult || [],
        };
      } else {
        alert(response.data.message || "Failed to fetch transactions");

        return {
          totalItemsCount: 0,
          searchResult: [],
        };
      }
    } catch (error) {
      console.error("API Error:", error);
      return null;
    }
  };
}






export function checkIfCustomerPhoneNoIsUnique(
phoneNo, customerID
) {
  return async (dispatch, getState) => {
    try {
      let storeId = null;

      const registration =
        getState().registration.registration || {};

      if (registration.hasOwnProperty("GlobalCustomer")) {
        if (!registration.GlobalCustomer) {
          storeId = getState().user.store.key;
        }
      }

      const params = {
        customerID,
        storeId,
        phoneNo
      };

      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/checkifcustomerphonenoisunique`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.isUnique;
      } else {
        alert("Failed to check customer phone no unique.");
        return null;
      }
    } catch (error) {
      console.error("API Error:", error);
      return null;
    }
  };
}


export function checkIfCustomerStoreMappingExists(
  saleToPurchaseStoreID,
  customerId
) {
  return async (dispatch, getState) => {
    try {
      let storeId = null;

      const registration =
        getState().registration.registration || {};

      if (registration.hasOwnProperty("GlobalCustomer")) {
        if (!registration.GlobalCustomer) {
          storeId = getState().user.store.key;
        }
      }

      const params = {
        customerId,
        storeId,
        saleToPurchaseStoreID,
      };

      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/checkifcustomerstoremappingexists`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.isExists;
      } else {
        alert("Failed to check customer store mapping.");
        return null;
      }
    } catch (error) {
      console.error("API Error:", error);
      return null;
    }
  };
}


export function pushCustomersToRedux(customers) {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_ACTIVE_CUSTOMERS, customers });
  };
}





export function getLoyaltyLedgersByCustomerID(customerID) {
  return async (dispatch, getState) => {
    try {
  
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/customers/loyaltyledges/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code == "0") {
       return { totalItemsCount:response.data.totalItemsCount, searchResult:response.data.searchResult };
      } else {
        return {};
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getPackagesByCustomerID(customerID) {
  return async (dispatch, getState) => {
    try {
  
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/customers/getpackagesbycustomerid/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code == "0") {
        return response.data.packages
      } else {
        return [];
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getTopProductsForACustomer(customerID, size) {
  return async (dispatch, getState) => {
    try {
      const params = {};

      if (size) {
        params.size = size;
      }

      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/customers/customerproducts/${customerID}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code == "0") {
        return {
          totalItemsCount: response.data.totalItemsCount,
          searchResult: response.data.searchResult,
        };
      } else {
        return {
          totalItemsCount: 0,
          searchResult: [],
        };
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getCustomerProductsFromDenomSales(customerID) {
  return async (dispatch, getState) => {
    try {

      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/crm/customers/customerallproducts/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code == "0") {
        return response.data.searchResult
      } else {
        return []
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function getUniqueNosByCustomerIdProductId(from, size, customerID, productID, storeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      // Build query parameters
      const params = new URLSearchParams();
      if (from !== undefined && from !== null) params.append('from', from);
      if (size !== undefined && size !== null) params.append('size', size);
      if (customerID && customerID.trim() !== '') params.append('customerID', customerID);
      if (productID && productID.trim() !== '') params.append('productID', productID);
      if (storeID && storeID.trim() !== '') params.append('storeID', storeID);

      const response = await axios.get(
        `${constants.API_URL}/transaction/inventory/uniquenosbycustomeridproductid`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: params, // Add the parameters here
        }
      );

      if (response.data.code === "0") {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


// export function getCustomerProducts(customerID) {
//   let searchParameters = {
//     size: 0,
//     query: {
//       bool: {
//         must: [
//           {
//             match: {
//               "CustomerID.keyword": customerID,
//             },
//           },
//         ],
//       },
//     },
//     aggs: {
//       products: {
//         terms: {
//           field: "ProductName.keyword",
//         },
//         aggs: {
//           total_sales: {
//             sum: {
//               field: "Amount",
//             },
//           },
//           total_qty: {
//             sum: {
//               field: "Qty",
//             },
//           },
//         },
//       },
//     },
//   };

//   return (dispatch, getState) => {
//     let addMessage = firebase.functions().httpsCallable("getDenomSales");
//     return addMessage({ text: searchParameters }).then(function(result) {
//       const products = [];
//       let sanitizedMessage = result.data.text;
//       sanitizedMessage.aggregations.products.buckets.map((data, index) => {
//         let product = {
//           name: data.key,
//           product_type: data.key.product_type,
//           total_quantity: Number(data.total_qty.value).toFixed(2),
//           total_sales: Number(data.total_sales.value).toFixed(2),
//         };
//         products.push(product);
//       });

//       return {
//         totalItemsCount: sanitizedMessage.hits.total.value,
//         searchResult: products,
//       };
//     });
//   };
// }
